import clsx from 'clsx';

import { UserDetail } from '@atom/types/user';

import classes from './hidotOvertimeReport.module.css';

type TeamRowProps = {
  user: UserDetail;
  hours: number;
  date: string;
};

const TeamRow = ({ user, hours, date }: TeamRowProps) => {
  return (
    <div className={classes.teamRow}>
      <div className={clsx(classes.teamCell, classes.name)}>
        {`${user?.firstName} ${user?.lastName}`}
      </div>
      <div className={clsx(classes.teamCell, classes.title)}>
        {user?.title || '-'}
      </div>
      <div className={clsx(classes.teamCell, classes.hours)}>{hours}</div>
      <div className={clsx(classes.teamCell, classes.date)}>{date}</div>
    </div>
  );
};

export default TeamRow;
